var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[_c('cookie-consent',{attrs:{"piwik-instance":_vm.$piwik}}),_c('Header'),_c('v-main',[_c('Main')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }